<template>
    <div class="how-to tmp-block">
        <h1>Как зайти на ВайнМайн?</h1>
        <h3>3 простых шага</h3>
        <div class="open-modal" @click="openModal">
            <secondary_button>Открыть инструкцию</secondary_button>
        </div>
        <img class="illustration" src="@/assets/illustrations/minecraft_world_cube.png" alt="">
    </div>
</template>

<script>
    import secondary_button from '@/elements/secondary_button.vue'
    import {mapMutations} from "vuex";

    export default {
        name: "how_to",
        components: {
            secondary_button
        },
        methods: {
            ...mapMutations('modal_instruction', ['openModal'])
        }
    }
</script>

<style scoped lang="scss">
    .how-to {
        position: relative;
        padding: 32px 124px 32px 48px !important;


        h1 {
            margin-bottom: 8px;
        }

        h3 {
            color: $text_gray !important;
            margin-bottom: 32px;
        }

        img.illustration {
            position: absolute;
            top: 6px; // 16
            right: -65px;
            animation: flying 12s ease-in-out infinite;
            animation-delay: 250ms;

            @keyframes flying {
                from, to {
                    transform: translateY(0);
                }
                50% {
                    transform: translateY(20px);
                }
            }
        }

        @include laptop {
            padding: 32px !important;
            padding-right: 124px !important;
        }
        @include tablet {
            img.illustration {
                top: 15px;
                right: -90px;
                animation: none;
            }
        }
        @include mobile{
            padding: 32px 102px 32px 24px !important;
            h1{
                padding-right: 50px;
            }
            h3{
                margin-bottom: 24px;
            }
        }
    }
</style>